import { Box } from '@mui/material';

import { FOOTER_HEADER } from '@src/layouts/configs';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        height: FOOTER_HEADER.HEIGHT,
        borderTop: (theme) => `1px solid ${theme.palette.custom.darkGrey}`,
      }}
    />
  );
};

export default Footer;
